import angular from 'angular';

export default window.angular = angular;